@if (isLoading) {
  <app-loader></app-loader>
}@else {
  <div class="login-main-container">
    <div class="login-left-container">
      <app-login-load></app-login-load>
    </div>
    <div class="login-right-container flex flex-column align-items-center justify-content-center bg-white px-7 ">

    <div class="flex align-items-center my-3 w-full">
        @if (_auth.appConfig() && _auth.appConfig().parentBrandLogoURL) {
          <div>
            <img [src]="_auth.appConfig().parentBrandLogoURL" alt="logo" class="logo" [style]="{ height:( _auth.appConfig().parentBrandLogoHeightLogin ? _auth.appConfig().parentBrandLogoHeightLogin + 'rem' : '4rem') }"/>
          </div>
          <div class="h-3rem bg-gray-300 mr-1" [style]="{width : '2px'}"></div>
        }
        @if (_auth.appConfig() && _auth.appConfig().brandLogoURL && _auth.appConfig().loginDefaultBrand === 'brandLogoURL') {
          <div>
            <img [src]="_auth.appConfig().brandLogoURL" alt="logo" class="logo" [style]="{ height:( _auth.appConfig().brandLogoHeightLogin ? _auth.appConfig().brandLogoHeightLogin + 'rem' : '4rem') }"/>
          </div>
        }@else if(_auth.appConfig() && _auth.appConfig().brandName && _auth.appConfig().loginDefaultBrand === 'brandName') {
          <div [style]="_auth.appConfig().brandNameStyle">
            {{_auth.appConfig().brandName}}
          </div>
        }@else if(_auth.appConfig() && _auth.appConfig().brandLogoURL && _auth.appConfig().brandName){
          <div>
            <img [src]="_auth.appConfig().brandLogoURL" alt="logo" class="logo" [style]="{ height:( _auth.appConfig().brandLogoHeightLogin ? _auth.appConfig().brandLogoHeightLogin + 'rem' : '4px') }"/>
          </div>
          <div [style]="_auth.appConfig().brandNameStyle">
            {{_auth.appConfig().brandName}}
          </div>
        }
      </div>

      <div class="w-full">
        @if(!isForgotPassword) {
          <app-login-form
            (updateisForgotPasswordEvent)="updateisForgotPassword($event)"
            (loginSuccessEvent)="onLoginSuccess()"
            [isSetIdpProvider]="isSetIdpProvider"
            [returnUrl]="returnUrl">
          </app-login-form>
        } @else {
          <app-forgot-password (updateisForgotPasswordEvent)="updateisForgotPassword($event)"></app-forgot-password>
        }
      </div>
    </div>
  </div>
}
